import { twMerge } from "tailwind-merge";

import { WRAPPER_STYLES } from "./wrapper";

export enum BUTTON_LAYOUT {
    footerNavigationPrimary = "footerNavigationPrimary",
    footerNavigationSecondary = "footerNavigationSecondary",
    headerNavigationBack = "headerNavigationBack",
    headerNavigationBase = "headerNavigationBase",
    headerNavigationOverview = "headerNavigationOverview",
    headerNavigationPrimary = "headerNavigationPrimary",
    headerNavigationSecondary = "headerNavigationSecondary",
    headerNavigationTab = "headerNavigationTab",
    plain = "plain",
    plainBig = "plainBig",
    primary = "primary",
    primaryBig = "primaryBig",
    primaryRounded = "primaryRounded",
    primarySquare = "primarySquare",
    secondary = "secondary",
    secondaryBig = "secondaryBig",
    secondaryRounded = "secondaryRounded",
    secondarySquare = "secondarySquare",
    tab = "tab",
}

export const BUTTON_STYLES: Record<BUTTON_LAYOUT, (active?: boolean) => string> = {
    primary: () =>
        "min-h-11 px-4 py-2 font-extrabold text-base flex items-center justify-center gap-2 rounded border border-brandYellow bg-brandYellow text-brandDark hover:border-yellowDarker hover:bg-yellowDarker disabled:border-grey3 disabled:bg-grey3 disabled:text-grey6",
    primaryBig: () => twMerge(BUTTON_STYLES.primary(), "min-h-14 text-lg"),
    primarySquare: () => twMerge(BUTTON_STYLES.primary(), "h-11 md:h-14 w-11 md:w-14 text-2xl"),
    primaryRounded: () => twMerge(BUTTON_STYLES.primary(), "rounded-full"),
    secondary: () =>
        twMerge(
            BUTTON_STYLES.primary(),
            "border-black bg-transparent text-brandDark hover:bg-greyOpacity10 hover:border-brandDark disabled:border-grey6 disabled:bg-transparent disabled:text-grey6",
        ),
    secondaryBig: () => twMerge(BUTTON_STYLES.secondary(), "min-h-14 text-lg"),
    secondarySquare: () => twMerge(BUTTON_STYLES.secondary(), "h-11 w-11 text-2xl"),
    secondaryRounded: () => twMerge(BUTTON_STYLES.secondarySquare(), "rounded-full"),
    plain: () =>
        twMerge(
            BUTTON_STYLES.secondary(),
            "border-transparent hover:border-transparent disabled:border-transparent",
        ),
    plainBig: () => twMerge(BUTTON_STYLES.plain(), "min-h-14 text-lg"),
    headerNavigationBase: () =>
        twMerge(
            WRAPPER_STYLES.HCenterLeft(),
            "text-greyDark text-base focus:outline-none min-h-11 px-4 py-1 rounded",
        ),
    headerNavigationBack: () =>
        twMerge(
            BUTTON_STYLES.headerNavigationBase(),
            "font-extrabold hover:bg-greyOpacity10 focus:bg-greyOpacity10 w-full md:w-auto",
        ),
    headerNavigationOverview: () =>
        twMerge(
            BUTTON_STYLES.headerNavigationBase(),
            "font-normal md:font-extrabold hover:bg-greyOpacity10 focus:bg-greyOpacity10 md:border-b w-full md:w-auto",
        ),
    headerNavigationPrimary: (active?: boolean) =>
        twMerge(
            BUTTON_STYLES.headerNavigationBase(),
            "font-normal hover:bg-greyOpacity10 focus:bg-greyOpacity10 py-2 md:py-0",
            active ? "md:bg-greyOpacity10" : "",
        ),
    headerNavigationTab: (active?: boolean) =>
        twMerge(
            BUTTON_STYLES.headerNavigationBase(),
            "font-normal md:py-2",
            active ? "active" : "",
        ),

    headerNavigationSecondary: (active?: boolean) =>
        twMerge(
            BUTTON_STYLES.headerNavigationBase(),
            "font-normal hover:bg-greyOpacity10 focus:bg-greyOpacity10 py-2 md:py-0 md:font-extrabold ",
            active ? "md:bg-greyOpacity10" : "",
        ),
    footerNavigationPrimary: (active?: boolean) =>
        twMerge(
            BUTTON_STYLES.headerNavigationBase(),
            "underline-offset-4 underline text-brandDark font-normal text-sm hover:bg-greyOpacity10 focus-within:bg-greyOpacity10 focus-within:outline-none py-2 md:py-0",
            active ? "md:bg-greyOpacity10" : "",
        ),
    footerNavigationSecondary: () =>
        twMerge(
            WRAPPER_STYLES.HCenterLeft(),
            "underline-offset-4 underline text-sm text-brandDark font-normal hover:bg-greyOpacity10 focus-within:bg-greyOpacity10 focus-within:outline-none min-h-11 px-3 py-1 whitespace-nowrap",
        ),
    tab: (active?: boolean) =>
        twMerge(
            BUTTON_STYLES.plain(),
            "text-brandDark text-base min-h-11 px-4 py-1 rounded",
            active
                ? "relative after:-bottom-0.5 after:absolute after:w-full after:border-b-2 after:border-b-brandDark"
                : "",
        ),
};
